import axiosInstance from './axiosInstance';
import axios from 'axios';

export const login = async (loginObj) => {
  const response = await axiosInstance.post(`/superAdminLogin`, loginObj);
  return response.data;
};

export const getReceptionist = async () => {
  const response = await axiosInstance.get(`/getreceptionist`);
  return response.data;
};

export const addReceptionist = async (newAdmin) => {
  const response = await axiosInstance.post(`/addReceptionist`, newAdmin);
  return response;
};

export const updateReceptionist = async (updatedAdmin) => {
  const response = await axiosInstance.post(`/updateReceptionist`, updatedAdmin);
  return response;
};

export const getHotels = async (params = {}) => {
  const response = await axiosInstance.get(`/getHotels`, { params });
  return response.data;
};

export const addHotel = async (newHotel) => {
  const response = await axiosInstance.post(`/addHotel`, newHotel);
  return response;
};

export const autoLogin = async (userId) => {
  const response = await axiosInstance.post(`/handlelogin`, {userId});
  return response.data;
};

export const updateHotel = async (updatedHotel) => {
  const response = await axiosInstance.post(`/updateHotel`, updatedHotel);
  return response;
};

export const addGuest = async (newGuest) => {
  const response = await axiosInstance.post(`/addGuest`, newGuest);
  return response;
};

export const getGuest = async (params = {}) => {
  const response = await axiosInstance.get(`/getGuests`, { params });
  return response;
};

export const getIncompleteGuest = async (params = {}) => {
  const response = await axiosInstance.get(`/getIncompleteGuestDetails`, { params });
  return response;
};

export const updateGuest = async (Guestdata) => {
  const response = await axiosInstance.post(`/updateGuest`, Guestdata);
  return response;
};

export const getEditGuest = async (checkInId, guestId = null, otherGuestsKey = "") => {
  const response = await axiosInstance.post(`/getSingleGuest`, { checkInId, guestId, otherGuestsKey});
  return response;
};

export const guestDataToupdate = async (checkInId,downloadInfo)=>{
  const response = await axiosInstance.post(`/getEditGuest`, { checkInId,downloadInfo });
  return response;
}

export const searchGuest = async (query) => {
  const response = await axiosInstance.get(`/serchGuest?q=${query}`);
  return response;
}

export const addRoom = async (Room) => {
  const response = await axiosInstance.post(`/addRoom`, Room);
  return response;
};

export const confirmcheckOut = async (checkoutDetails) => {
  const response = await axiosInstance.post(`/confirmcheckout`, checkoutDetails);
  return response;
};

export const getRoom = async () => {
  const response = await axiosInstance.get(`/getRoom`);
  return response.data;
};

export const getRoomData = async () => {
  const response = await axiosInstance.get(`/getRoomdata`);
  return response.data;
};

export const updateRoom = async (Room) => {
  const response = await axiosInstance.post(`/updateRoom`, Room);
  return response;
};

export const createHotelWithManager = async (hotelData) => {
  const response = await axiosInstance.post(`/addhotelandmanager`, hotelData);
  return response;
};

export const updateHotelAndManager = async (hotelData) => {
  const response = await axiosInstance.post(`/updatehotelandmanager`, hotelData);
  return response;
};

export const deleteHotelWithManager = async (hotelId) => {
  const response = await axiosInstance.post(`/deletehotelandmanager`, { hotelId });
  return response;
};

export const changePassword = async (newPassword) => {
  const response = await axiosInstance.post(`/resetpassword`, {
    newPassword
  });
  return response.data;
};

export const changePasswordWithOld = async (oldPassword, newPassword) => {
  const response = await axiosInstance.post(`/changepassword`, {
    oldPassword, newPassword
  });
  return response.data;
};

export const getStatsData = async () => {
  const response = await axiosInstance.get(`/superadminDashboard`);
  return response.data;
};

export const getMonthlyRevenueTrend = async (range) => {
  const response = await axiosInstance.get(`/revenue-trend?range=${range}`);
  return response.data;
};

export const getRevenueDistribution = async (range) => {
  const response = await axiosInstance.get(`/revenue-distribution?range=${range}`);
  return response.data;
};
export const cancelCheckIn = async (checkInId) => {
  const response = await axiosInstance.post(`/cancelCheckIn`, { checkInId });
  return response.data;
};


export const deleteCheckIn = async (checkInId) => {
  const response = await axiosInstance.post(`/deleteCheckIn`, { checkInId });
  return response.data;
};

export const changeManagerStatus = (id, isActive) => {
  const response = axiosInstance.post(`/change-statusrec`, { id, isActive });
  return response;
};

export const changeHotelStatus = async (hotelId, isActive) => {
  const response = await axiosInstance.post('/changeHotelandManagerstatus', {
    hotelId,
    isActive,
  });
  return response;
};
export const changeRoomStatus = async (roomId, roomStatus) => {
  const response = await axiosInstance.post('/updateRoomstatus', { roomId, roomStatus });
  return response;
};

export const changeCleaningStatus = async (roomId, underCleaning) => {
  const response = await axiosInstance.post('/updateRoomCleaningstatus', { roomId, underCleaning });
  return response;
};

export const importGuestsFromCSV = async (formData) => {
  const response = await axiosInstance.post('/import-csvfile', formData);
  return response;

};

export const getCleaningData = async (params = {}) => {
  const response = await axiosInstance.get(`/getcleaning-data`, { params });
  return response;
};


export const resetPassword = async (userId)=>{
  const response = await axiosInstance.post('/forgotpassword', {
    userId 
  });
  return response;
}


export const sucessCheckin = async (filters)=>{
  const response = await axiosInstance.post('/successful-checkincount', filters );
  return response.data;
}

export const addCredit = async (payload)=>{
  const response = await axiosInstance.post('/add-hotel-credit', payload );
  return response.data;
}

export const fetchHotelCredit = async (payload)=>{
  const response = await axiosInstance.post('/fetch-credit-details', payload );
  return response.data;
}


export const getCredit = async ()=>{
  const response = await axiosInstance.get('/credit' );
  return response.data;
}

// add-pathkentry
export const addPathikEntry = async (checkInIds)=>{
  const response = await axiosInstance.post('/processToAdd', {
    checkInIds 
  });
  return response;
}

export const extractData = async (files)=>{
  const response = await axios.post(`${process.env.REACT_APP_DATA_EXTRACT_URL}`, 
    files 
  );
  return response.data.data;
}


export const getCurrentLocalDateTime = () => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000;
  const localTime = new Date(now.getTime() - timezoneOffset);
  const isoString = localTime.toISOString().slice(0, 16);
  const [date, time] = isoString.split("T");
  return { date, time, dateTime: isoString };
};


export const calculateStayDuration = (checkIn, checkOut) => {  
  const diffInMs = checkOut - checkIn;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes}`;
};

export const calculatePayableAmount = (stayHours, gracePeriod, hourlyPricing,checkIn,
  checkOut,
  nightCheckInConfirmed,
  nightStayPrice
) => {

  let payableAmount = 0;
  // Convert "hours:minutes" format to total minutes
  const [hours, minutes] = stayHours.split(":").map(Number);
  let stayMinutes = (hours * 60) + minutes;

  const actualCheckIn = new Date(checkIn); 
  const actualCheckOut = new Date(checkOut);

  if (nightCheckInConfirmed) {
    // Create 9:00 AM on the day of checkOut
    const nightEnd = new Date(actualCheckIn);
    nightEnd.setHours(9, 0, 0, 0); // 9:00 AM
    if (actualCheckIn.getHours() < 9 || (actualCheckIn.getHours() === 9 && actualCheckIn.getMinutes() === 0 && actualCheckIn.getSeconds() === 0)) {
    // same day 9:00 AM
     nightEnd.setHours(9, 0, 0, 0);
    } else {
    // next day 9:00 AM
    nightEnd.setDate(nightEnd.getDate() + 1);
    nightEnd.setHours(9, 0, 0, 0);
    }
    const nightStart = new Date(nightEnd);
    nightStart.setDate(nightEnd.getDate() - 1);
    nightStart.setHours(19, 0, 0, 0);

    if (actualCheckOut >= nightStart && actualCheckOut <= nightEnd) {
      return {
        payableHours: 0,
        payableAmount: nightStayPrice
      };
    }
    else if(actualCheckOut > nightEnd){
      const diffInMs = nightEnd - actualCheckIn
      const nightStayMinutes = Math.floor(diffInMs / (1000 * 60));
      stayMinutes -= nightStayMinutes
      payableAmount += nightStayPrice;
    }
   }
  const totalMinutes = Math.max(stayMinutes - gracePeriod, 0); 
  //Convert back to hours and round up to the next full hour
  let totalPaybleHours = Math.max(Math.ceil(totalMinutes / 60), 1);
  const payableHours = totalPaybleHours
  //Sort pricing by hours in ascending order
  if (hourlyPricing?.length > 0) {
    const sortedPricing = [...hourlyPricing].sort((a, b) => a.hours - b.hours);
  do{
  for (const tier of sortedPricing) {
    if (totalPaybleHours <= tier.hours) {
      payableAmount = payableAmount + tier.price;
      totalPaybleHours = totalPaybleHours - tier.hours;
      break;
    }
  }
  if ((payableAmount === 0 || totalPaybleHours > 0) && sortedPricing.length > 0) {
    const highestTier = sortedPricing[sortedPricing.length - 1];
    payableAmount = payableAmount + highestTier.price;
    totalPaybleHours = totalPaybleHours - highestTier.hours;
  }
  } while(totalPaybleHours > 0)
 
  }
  return {
    payableHours,
    payableAmount
  };
};

export const formatTimeToAMPM = (timeString) => {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  const time = new Date(0, 0, 0, hours, minutes);
  return time.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).replace(/^0/, '');
};


export const validateCheckInData = (bookingData) => {
  const errors = [];

  // Helper to check if a value is empty
  const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && Object.keys(value).length === 0) return true;
    return false;
  };

  // Check if the entire bookingData is empty
  if (isEmpty(bookingData)) {
    return { isValid: false, message: "All fields must be filled" };
  }

  // Validate top-level required fields
  const requiredTopFields = [
    'roomNumber', 'guestId', 'checkInDate', 'checkInTime',
    'numberOfAdults', 'numberOfChildren',
    'documentNumber', 'documentType', 'documentUrl'
  ];

  for (const field of requiredTopFields) {
    if (isEmpty(bookingData[field])) {
      errors.push(`Field '${field}' cannot be empty`);
    }
  }
  // Validate 'guestId' object
  if (!isEmpty(bookingData.guestId)) {
    const requiredGuestFields = [
      'firstName', 'lastName', 'mobileNumber', 'dateOfBirth',
      'phoneNumber', 'emailAddress', 'comingFrom', 'goingTo'
    ];
    for (const field of requiredGuestFields) {
      if (isEmpty(bookingData.guestId[field])) {
        errors.push(`Field 'guestId.${field}' cannot be empty`);
      }
    }

    // Validate 'address' object
    if (!isEmpty(bookingData.guestId.address)) {
      const requiredAddressFields = ['address', 'locality', 'city', 'district', 'zipCode', 'country', 'state'];
      for (const field of requiredAddressFields) {
        if (isEmpty(bookingData.guestId.address[field])) {
          errors.push(`Field 'guestId.address.${field}' cannot be empty`);
        }
      }
    }
  }

  // Validate 'otherGuests' array
  if (!isEmpty(bookingData.otherGuests)) {
    bookingData.otherGuests.forEach((guest, index) => {
      const requiredGuestFields = ['fullName', 'mobileNumber', 'documentType', 'documentNumber'];
      for (const field of requiredGuestFields) {
        if (isEmpty(guest[field])) {
          errors.push(`Field 'otherGuests[${index}].${field}' cannot be empty`);
        }
      }
    });
  }

  // Validate 'documentUrl' array
  if (!isEmpty(bookingData.documentUrl)) {
    if (bookingData.documentUrl.some(url => isEmpty(url))) {
      errors.push(`Field 'documentUrl' cannot contain empty strings`);
    }
  }

  return {
    isValid: errors.length === 0,
    errors: errors.length > 0 ? errors : null,
    message: errors.length > 0 ? "Incomplete checkIn Details" : "All fields are valid"
  };
};

let logoutFn = () => {};

export const setLogoutFunction = (fn) => {
  logoutFn = fn;
};

export const triggerLogout = () => {
  logoutFn();
};

export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();
  if (days < 0) {
    months -= 1;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }
  return { years, months, days };
};





 
    // const verifyDate = new Date();
    // Create 7:00 PM on the day before checkOut
    // const nightStart = new Date(verifyDate);
    // nightStart.setDate(verifyDate.getDate() - 1);
    // nightStart.setHours(19, 0, 0, 0); // 7:00 PM
    // console.log("nightStart",nightStart)